import { render } from "./FuturesBalanceDeltaActionNumberWidgetParams.vue?vue&type=template&id=035ac5da"
import script from "./FuturesBalanceDeltaActionNumberWidgetParams.vue?vue&type=script&lang=js"
export * from "./FuturesBalanceDeltaActionNumberWidgetParams.vue?vue&type=script&lang=js"
script.render = render

export default script